module.exports = __webpack_public_path__ + "img/img_eventPopup_top.c7dda51c.png";